
supportStaff = ($http, ApiUrl, ModelService) ->
    'ngInject'

    restrict: 'E'
    templateUrl: 'programs/initiatives/amcSupportStaff'
    scope:
        program: '='
        editable: '='
        log: '='

    link: (scope) ->
        url = ApiUrl('ybusa_staff', 'search')

        scope.search = (query) ->
            $http.get(url, {params: {q: query, department: ['americorps']}})
                .then (response) -> response.data.staff

        scope.save = (data) ->
            data =
                portfolio_manager_id: data.portfolio_manager?.id or null
                financial_manager_id: data.financial_manager?.id or null

            ModelService.patch('program', scope.program.id, data)


module.directive('amcSupportStaff', supportStaff)